'use strict';

angular.module('v-tv-package').config(function ($translateProvider, $analyticsProvider, $windowProvider, tvPackageConfigProvider) {
    var appConfig = tvPackageConfigProvider.$get();
    var document = $windowProvider.$get().document;
    var lang = document.documentElement.getAttribute('lang') || 'fr';

    $translateProvider.useSanitizeValueStrategy('sanitize');
    $translateProvider.translations('en', appConfig.i18n.en);
    $translateProvider.translations('fr', appConfig.i18n.fr);
    $translateProvider.use(lang);

    /** angulartics */
    $analyticsProvider.firstPageview(true);
    $analyticsProvider.withAutoBase(true);
});